<div class="modal-all">
  <div class="modal-header">
    <h4 class="modal-title pull-left">
      {{ "modals.add_assignament.title" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="closeCanvas()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div id="modal_add_assignament"></div>
    <form
      [formGroup]="assignamentForm"
      (ngSubmit)="saveAssignament()"
      class="assignment-form"
    >
      <div class="form-container">
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{ "modals.add_assignament.zone_input" | translate }}*</label
            >

            <ng-select
              formControlName="zoneId"
              [items]="zones"
              bindLabel="zoneName"
              bindValue="zoneName"
              [multiple]="false"
              class="custom_select custom_select_single input_form"
              placeholder="{{
                'modals.add_assignament.zone_input' | translate
              }}"
            >
            </ng-select>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{ "modals.add_assignament.date_input" | translate }}*</label
            >
            <input
              type="date"
              formControlName="targetDate"
              class="form-control"
              id="myDatePicker"
            />
          </div>
        </div>

        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.time_margen_input" | translate
              }}*</label
            >
            <tui-input
              formControlName="generalTimeMargin"
              class="input_form"
              tuiHintContent="Tiempo extra que se asigna a cada servicio (al margen de movilidad, proveedores y toppings)"
              tuiHintDirection="bottom"
              tuiHintAppearance="onDark"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{ "modals.add_assignament.time_margen_input_text" | translate }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.provider_time_margen_input" | translate
              }}*</label
            >
            <tui-input
              formControlName="exterProviderTimeMargin"
              class="input_form"
              tuiHintContent="Tiempo extra que se añade por cada tarea en un proveedor, además del ya establecido por cada producto"
              tuiHintDirection="bottom"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.provider_time_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.topping_time_margen_input" | translate
              }}*</label
            >
            <tui-input
              formControlName="extraToppingTimeMargin"
              class="input_form"
              tuiHintContent="Tiempo asignado para cada topping"
              tuiHintDirection="bottom"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.topping_time_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.walk_driver_time_margen_input"
                  | translate
              }}*</label
            >
            <tui-input
              formControlName="maxDriverWalkTime"
              class="input_form"
              tuiHintContent="Tiempo máximo a pie por conductor y viaje"
              tuiHintDirection="bottom"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.walk_driver_time_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.public_transport_time_margen_input"
                  | translate
              }}*</label
            >
            <tui-input
              formControlName="maxDriverPublicTransportTime"
              class="input_form"
              tuiHintContent="Tiempo en transporte público por viaje"
              tuiHintDirection="bottom"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.public_transport_time_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.auxiliar_range_margen_input"
                  | translate
              }}*</label
            >
            <tui-input
              formControlName="sweepCarRadiusInKilometers"
              class="input_form"
              tuiHintContent="Tiempo máximo entre cada parada del coche escoba"
              tuiHintDirection="bottom"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.auxiliar_range_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
        
        <div class="form-group">
          <div class="form-field">
            <label class="label_form"
              >{{
                "modals.add_assignament.auxiliar_time_margen_input" | translate
              }}*</label
            >
            <tui-input
              formControlName="sweepCarMaxArrivalTime"
              class="input_form"
              [tuiTextfieldLabelOutside]="true"
              tuiTextfieldIcon="tuiIconClock"
            >
              00 min
              <input
                tuiTextfield
                type="text"
                (keypress)="allowOnlyNumbers($event)"
              />
            </tui-input>
            <span class="sub_input_text">
              {{
                "modals.add_assignament.auxiliar_time_margen_input_text"
                  | translate
              }}
            </span>
          </div>
        </div>
      </div>
    </form>

    <app-assignation-sidebar-panel
      [includedDrivers]="selectedDrivers.length"
      [totalDrivers]="availableDrivers.length"
      [isLoadingDrivers]="isDriversLoading"
      (viewAll)="openDriversSelectionModal()"
    ></app-assignation-sidebar-panel>
  </div>
  
  <div class="modal-footer">
    <button
      tuiButton
      type="button"
      class="btn_desc but_footer"
      size="m"
      appearance="secondary"
      (click)="closeCanvas()"
      [disabled]="isSubmitting"
    >
      {{ "modals.add_assignament.close_modal_text" | translate }}
    </button>
    <button
      [disabled]="!isFormValid || isSubmitting || isDriversLoading"
      tuiButton
      type="button"
      (click)="saveAssignament()"
      class="but_footer"
      size="m"
      appearance="primary-button"
      [icon]="isSubmitting ? '' : 'tuiIconPlusCircleLarge'"
    >
      <span *ngIf="isSubmitting" class="button-content">
        <tui-loader size="s" class="loader-inline"></tui-loader>
        {{ "modals.add_assignament.processing" | translate }}
      </span>
      <span *ngIf="!isSubmitting" class="button-content">
        {{ "modals.add_assignament.add_button_text" | translate }}
      </span>
    </button>
  </div>
</div>
